import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getCasinoGameCategories = (data: PropertyType): Promise<PropertyType> =>
	api.post(`games/categories${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
